<template>
  <div class="grandTable" role="grandTable" tabindex="0">
    <table class="table" ref="table">
      <thead>
        <tr>
          <th
            v-for="(column, index) in columns.filter(ff=>ff.colspan !== 0)"
            :key="`${column.field}-${index}`"
            :style="column.colStyle"
            :class="`stickyTop ${column.sticky ? 'stickyLeft ' : ''}${
              column.stickyRight ? 'stickyRight ' : ''
            }`"
            :data-index="index"
            :data-field="column.field"
            :data-sticky="
              column.sticky ? 'left' : column.stickyRight ? 'right' : ''
            "
            :colspan="column.colspan"
          >
            <slot
              :name="`${column.field}-header`"
              :data="data"
              :header="column"
              :title="column.title"
            >
              {{ column.title }}
            </slot>
            <i
              v-if="false && column.filterable"
              class="fa fa-filter text-muted pointer px-1"
              :id="column.field"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            ></i>

            <i
              v-if="column.sortable"
              class="fa pointer px-1"
              :class="`fa-sort${sorted(column.field)} ${
                sort[column.field] ? 'color_active' : 'text-muted'
              }`"
              @click="(_) => sortData(column)"
            ></i>
            <ul
              v-if="false && column.filterable"
              class="dropdown-menu"
              style="padding: 3px"
              :aria-labelledby="column.field"
            >
              <div class="input-group input-group-sm">
                <input
                  type="search"
                  placeholder="Search fechahora_amigable..."
                  class="form-control"
                /><span class="input-group-btn"
                  ><button class="btn btn-default fa fa-search"></button
                ></span>
              </div>
            </ul>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="empty-row" v-if="data.length === 0">
          <td :colspan="columns.length" class="text-center">
            <div class="d-flex align-items-center justify-content-center">
              No hay datos
            </div>
          </td>
        </tr>
        <tr v-for="(row, r_index) in data" :key="r_index" :style="row.rowStyle">
          <slot
            v-for="(column, c_index) in columns"
            :name="column.field"
            :row="row"
            :column="row[column.field]"
            :index="r_index"
            :className="`${column.sticky ? 'stickyLeft ' : ''}${
              column.stickyRight ? 'stickyRight ' : ''
            }`"
            :colStyle="column.colStyle"
          >
            <td
              :class="`${column.sticky ? 'stickyLeft ' : ''}${
                column.stickyRight ? 'stickyRight ' : ''
              }`"
              :key="`${column.field}-${r_index}-${c_index}`"
              :style="column.colStyle"
            >
              {{ row[column.field] }}
            </td>
          </slot>
        </tr>
      </tbody>
    </table>
    <div
      v-if="loading"
      style="
        inset: 0;
        position: absolute;
        background-color: rgba(255, 255, 255, 0.4);
        z-index: 10;
      "
    >
      <div
        style="
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
        "
      >
        <div
          role="status"
          aria-hidden="false"
          aria-label="Loading"
          class="spinner-grow spinner-grow-lg text-primary"
        ></div>
      </div>
    </div>
    <slot name="under-table"></slot>
  </div>
</template>

<script>
export default {
  name: "GrandTable",
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  updated() {
    const ths = [...this.$refs.table.querySelector("thead > tr").children];
    const trs = [...this.$refs.table.querySelector("tbody").children];
    let left = 0,
      right = 0;
    ths
      .filter((th) => th.dataset.sticky === "left")
      .forEach((th) => {
        th.style.left = `${left}px`;
        trs.forEach((tr) => {
          if (tr.children[th.dataset.index]?.style) {
            tr.children[th.dataset.index].style.left = `${left}px`;
          }
        });
        left += th.offsetWidth;
      });
    ths
      .filter((th) => th.dataset.sticky === "right")
      .reverse()
      .forEach((th) => {
        th.style.right = `${right}px`;
        trs.forEach((tr) => {
          if (tr.children[th.dataset.index]?.style) {
            tr.children[th.dataset.index].style.right = `${right}px`;
          }
        });
        right += th.offsetWidth;
      });
  },
  data() {
    return {
      sort: {},
    };
  },
  methods: {
    sorted(field) {
      return this.sort[field] ?? "";
    },
    sortData({ field, join, sort }) {
      if (this.sort[field] === "-down") {
        this.sort = { [field]: "-up" };
        this.$emit("sort", {
          field: join ?? sort ?? field,
          order: "asc",
          join: !!join,
        });
      } else {
        this.sort = { [field]: "-down" };
        this.$emit("sort", {
          field: join ?? sort ?? field,
          order: "desc",
          join: !!join,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.grandTable[role="grandTable"] {
  // @import url("https://fonts.googleapis.com/css2?family=Fraunces:ital,wght@0,700;1,200&display=swap");

  table {
    .stickyRight,
    .stickyLeft {
      position: sticky;
      z-index: 2;
    }
    .stickyLeft {
      left: 0;
    }
    .stickyRight {
      &,
      .open ul {
        right: 0;
      }
    }
    white-space: nowrap;
    margin: 0;
    td,
    th {
      padding: 0.5rem 1rem;
      position: relative;
    }
    thead {
      th.stickyTop {
        position: sticky;
        top: 0;
        z-index: 3;
        background: white;
        &.open {
          z-index: 3;
          .dropdown-menu {
            display: block;
          }
        }
      }
    }

    tbody {
      tr:nth-of-type(odd) {
        background-color: #e9e9eb;
      }
      tr {
        background-color: white;
      }
      td {
        padding: 0.75rem;
        vertical-align: top;
        border-top: 1px solid;
        border-top-color: #d8dbe0;
        background-color: inherit;
      }
      //   th {
      //     font-weight: 100;
      //     font-style: italic;
      //     text-align: left;
      //     position: relative;
      //   }

      > .sticky {
        position: sticky;
        left: 0;
        background: white;
        z-index: 1;
      }
    }
  }

  &[tabindex] {
    width: 100%;
    max-height: 90vh;
    overflow: auto;
  }
}
.pointer {
  cursor: pointer;
}
.color_active {
  color: #321fdb;
}
.empty-row {
  td {
    height: 100px;
  }
}
</style>
<style lang="scss"></style>
